<template>
  <canvas></canvas>
</template>

<script>
import timelineCanvas from './mixins/timelineCanvas.js';
import canvasUtils from './modules/canvasUtils.js';
import Color from '../../../modules/Color.js';
import TimeValue from '../../../modules/TimeValue.js';

const playTimeBarColor = new Color(255, 0, 0, 1);

export default {
  mixins: [
    timelineCanvas,
  ],

  watch: {
    playTime: {
      handler() { this.$_setDirty(true) },
      deep: true,
    },
    isPlayTimeInView() { this.$_setDirty(true) },
    followPlayBarFlag() { this.$_setDirty(true) },
    timelineViewBegin: {
      handler() { this.$_setDirty(true) },
      deep: true,
    },
  },

  props: {
    rulerVerticalOffsetPx: { type: Number },
    playTime:              { type: TimeValue },
    isPlayTimeInView:      { type: Boolean },
    followPlayBarFlag:     { type: Boolean },
    timelineViewBegin:     { type: TimeValue },
  },

  inject: [
    'scaledTimeToPx',
  ],

  methods: {
    /* public */
    draw() {
      this.$_draw(() => {
        if (this.isPlayTimeInView) {
          let playTimelineViewOffset = this.playTime.getOffsetFrom(this.timelineViewBegin);
          let playTimelineViewOffsetPx = this.scaledTimeToPx(playTimelineViewOffset);
          drawBar.call(this, playTimelineViewOffsetPx, this.$data.$_timelineCanvasHeightPx, playTimeBarColor.styleString);
          if (this.followPlayBarFlag) {
            drawFollowPlayTimeBarIndicator.call(this, playTimelineViewOffsetPx, playTimeBarColor.styleString, this.rulerVerticalOffsetPx);
          }
        }
      });

      function drawBar(timeOffsetPx, timelineCanvasHeightPx, color) {
        let timelinePlayTimeBarCanvas = this.$data.$_timelineCanvasContext;
        canvasUtils.drawLine(
          timelinePlayTimeBarCanvas,
          { x: timeOffsetPx, y: 0 },
          { y: timelineCanvasHeightPx },
          { lineWidth: 1, strokeStyle: color, lineDash: [] },
        );
      }

      function drawFollowPlayTimeBarIndicator(playTimelineViewOffsetPx, playTimeBarColor, rulerVerticalOffsetPx) {
        let timelinePlayTimeBarCanvas = this.$data.$_timelineCanvasContext;
        canvasUtils.drawLine(
          timelinePlayTimeBarCanvas,
          { x: playTimelineViewOffsetPx - 10, y: 2 },
          { x: playTimelineViewOffsetPx - 4, y: rulerVerticalOffsetPx / 2 },
          { lineWidth: 1 },
        );
        canvasUtils.drawLine(
          timelinePlayTimeBarCanvas,
          { x: playTimelineViewOffsetPx - 4, y: rulerVerticalOffsetPx / 2 },
          { x: playTimelineViewOffsetPx - 10, y: rulerVerticalOffsetPx - 2 },
          { lineWidth: 1 },
        );
      }
    },
  }
};
</script>
